import React from "react";
import imgg from "../Assets/123.jpeg";
// import Hero from "components/hero/BackgroundAsImageWithCenteredContent.js";
import Hero from "../Components/Hero";
import Footer from "../Layout/Footer";
import DonateBar from "../Components/DonateBar";
import Partners from "../Components/Partners";
import BlogSection from "../Components/BlogSection";
import About from "../Components/About";
import Projects from "../Components/Projects";
import { useEffect } from "react";
import OurTeam from "../Components/OurTeam";
import Aos from "aos";
import "aos/dist/aos.css";

const Home = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {/*<Hero />*/}
      <Hero />
      <div className=''>
        <div className='bg-white bg-opacity-80'>
          {/* <Partners /> */}
          <div data-aos='fade-up' className=''>
            <About />
          </div>

          <div data-aos='fade-up' className=''>
            <Projects />
          </div>

          <div data-aos='fade-up' className=''>
            <OurTeam />
          </div>

          <BlogSection />
          <DonateBar />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
